import * as yup from 'yup';

export type ContactFormData = yup.InferType<typeof contactSchema>;

export const contactSchema = yup.object({
  email: yup
    .string()
    .email('error.form.invalidEmail')
    .required('error.form.required'),
  message: yup.string().required('error.form.required'),
});
